import { ReactNode } from 'react';

import Sticker from 'design-system/components/Sticker';

interface PiiProps {
  children?: ReactNode;
  isRedacted: boolean;
  hideOnRedacted?: boolean;
}

const Pii = ({ children, isRedacted, hideOnRedacted }: PiiProps) => {
  if (isRedacted) {
    return hideOnRedacted ? null : <Sticker data-test='pii__redacted'>Redacted</Sticker>;
  }

  if (children == null || children === '') {
    return null;
  }

  // There used to be code inserting a classname here in certain cases. There's
  // no other reason for this to be conditionally wrapped in a span, but
  // removing it breaks a lot of tests. Someday, the tests will be fixed...
  // hopefully.
  if (['string', 'number'].includes(typeof children)) {
    return <span>{children}</span>;
  }

  return <>{children}</>;
};

export default Pii;
